export default "__VITE_ASSET__C_gVimqg__"